import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../widgets/form/InputDateUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import { useState } from 'react'

const AddChargeAmountUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
	addMode, submitted, onSubmit, onCancelClick,
	invoiceNumber, onInvoiceNumberChange, invoiceNumberError, setInvoiceNumberError,
	invoiceDateISO, onInvoiceDateISOChange, invoiceDateISOError, setInvoiceDateISOError,
	chargeAmountF, onChargeAmountFChange, chargeAmountFError, setChargeAmountFError,
	remarks, onRemarksChange, remarksError, setRemarksError,
	dueDateISO, onDueDateISOChange, dueDateISOError, setDueDateISOError,
	fileInput, alreadyPaid
}) => {
	return (
		<ModalFormUI
			context={context}
			titleLabel='Update Out-of-pocket Expenses'
			buttonLabel='Update'
			cancelLabel='Cancel'
			isOpen={addMode}
			onRequestClose={onCancelClick}
			successMsg={successMsg}
			errorList={errorList}
			setErrorList={setErrorList}
			onSubmit={onSubmit}
			busy={submitted}
		>

			<InputTextSF
				type='text' name='invoiceNumber' label='Invoice Number'
				value={invoiceNumber} onChange={onInvoiceNumberChange}
				error={invoiceNumberError} setError={setInvoiceNumberError}
			/>

			<InputDateUI context={context} name='invoiceDateISO' label='Invoice Date'
				selectedDateISO={invoiceDateISO} onChange={onInvoiceDateISOChange}
				error={invoiceDateISOError} setError={setInvoiceDateISOError}
			/>

			{!alreadyPaid &&
				<div>
					<InputTextSF
						type='text' name='chargeAmountF' label='OOPE Amount'
						value={chargeAmountF} onChange={onChargeAmountFChange}
						error={chargeAmountFError} setError={setChargeAmountFError}
					/>

					<InputDateUI context={context} type='date' name='dueDateISO' label='Due Date'
						selectedDateISO={dueDateISO} onChange={onDueDateISOChange}
						error={dueDateISOError} setError={setDueDateISOError}
					/>

					<InputTextSF
						type='text' name='remarks' label='Remarks'
						value={remarks} onChange={onRemarksChange}
						error={remarksError} setError={setRemarksError}
					/>
				</div>
			}

		</ModalFormUI>
	)
}

export default AddChargeAmountUpdateModalUI
